const select = 'id,title,description,reportGroupId,isPublic,isActive,type,powerBIReportID';

export default {
  paged: {
    select: 'id,isActive,order,type,title,powerBIReportId,isPublic',
    searchSelect: ['title', 'powerBIReportId', 'reportGroup/name'],
    orderBy: 'order',
    expand: {
      reportGroup: { select: 'id,name' },
    },
  },
  // Embedded detail (`/reports/:groupId/:reportId`) — no restrictive `$select`
  // so Power BI filter flags are preserved; expand group for the hero.
  report: {
    expand: {
      reportGroup: { select: 'id,name' },
    },
  },
  item: {
    expand: {
      reportGroup: { select: 'id,name' },
      reportDataFilterDynamicEntity: { select: 'id,displayName' },
    },
  },
  itemDetail: {
    expand: {
      reportGroup: { select: 'id,name' },
      reportDataFilterDynamicEntity: { select: 'id,displayName' },
      userCreator: { select: 'fullName' },
      userModifier: { select: 'fullName' },
    },
  },
  groups: {
    select: 'id,name',
    searchSelect: ['name'],
    notSelectSearch: 'reports',
    expand: {
      reports: { count: true },
    },
  },
  reports: {
    select,
    searchSelect: ['title', 'description', 'reportGroup/name'],
    notSelectSearch: 'reportGroup',
    expand: {
      reportGroup: { select: 'id,name' },
    },
    orderBy: 'order',
  },
  favorites: {
    select,
    searchSelect: ['title', 'description'],
    notSelectSearch: 'reportGroup,reports',
    expand: {
      reportGroup: { select: 'id,name' },
    },
    orderBy: 'order',
  },
};
